import { Fragment, useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { Button, Input, Table } from "reactstrap";
import { getAdminCompanyDeviceIssue, getAdminCompanyDeviceUpdateForIssue } from "../../slices/admin/thunk";
import { useDispatch, useSelector } from "react-redux";
import CompanyDropdown from "./CompanyDropdownMenu";
import DeviceDropdown from "./DeviceDropdownMenu";
import AdminDeviceRecordModal from "./AdminDeviceRecordModal";
import LimitDropdown from "./LimitDropdown";
import { SELECTION_ALL } from "../../common/constants";
import IssueStatusDropdown from "./IssueStatusDropdown";
import AdminDeviceIssueRow from "./AdminDeviceIssueRow";

function AdminDeviceIssue(props) {
    console.log("AdminDeviceIssue rendered");
    const { t } = useTranslation();
    const dispatch = useDispatch();
    document.title = t('PageMain.DocumentTitle');
    const issues = useSelector(state => state.Admin.issue);
    const [searchWord, setSearchWord] = useState("");
    const [debouncedSearch, setDebouncedSearch] = useState("");
    const [isShowModal, setShowModal] = useState(false);
    const [modalDevice, setModalDevice] = useState(null);
    const [selectedCompany, setSelectedCompany] = useState(props.selectedDevice === null ? SELECTION_ALL : props.selectedDevice.companyID);
    const [selectedDevice, setSelectedDevice] = useState(props.selectedDevice === null ? SELECTION_ALL : props.selectedDevice.deviceID);
    const [selectedStatus, setSelectedStatus] = useState(SELECTION_ALL);
    const [issueID, setIssueID] = useState(undefined);
    const [limit, setLimit] = useState(20);

    async function fetchData(selectedDeviceID, selectedCompanyID, selectedStatus, debouncedSearch) {
        console.log("fetchData", selectedDeviceID);
        dispatch(getAdminCompanyDeviceIssue(selectedDeviceID, selectedCompanyID, selectedStatus, debouncedSearch, limit));
    }

    useEffect(() => {
        fetchData(selectedDevice, selectedCompany, selectedStatus, debouncedSearch);
    }, [limit, selectedDevice, selectedCompany, selectedStatus, debouncedSearch])

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedSearch(searchWord);
        }, 400); // wait 400ms after last keystroke

        return () => clearTimeout(timer);
    }, [searchWord]);

    useEffect(() => {
        fetchData(props.selectedDevice.deviceID, props.selectedDevice.companyID, selectedStatus);
        setSelectedDevice(props.selectedDevice.deviceID);
        setSelectedCompany(props.selectedDevice.companyID);
    }, [props.selectedDevice])

    const handleSelectCompany = (companyID) => {
        fetchData(selectedDevice, companyID, selectedStatus);
        setSelectedCompany(companyID);
        setSelectedDevice(""); // Reset device selection when company changes
    };

    const handleSelectDevice = (deviceID) => {
        fetchData(deviceID, selectedCompany, selectedStatus);
        setSelectedDevice(deviceID);
    };

    const handleSelectStatus = (status) => {
        fetchData(selectedDevice, selectedCompany, status);
        setSelectedStatus(status);
    };

    const setShowCreateUpdateModal = (deviceID, issueID) => {
        setModalDevice(deviceID);
        setIssueID(issueID);
        setShowModal(true);
    }

    return (
        <Fragment>
            <div className="d-flex flex-row align-items-start justify-content-between">
                <div className="d-flex flex-row align-items-start justify-content-start">
                    <Button size="sm" color="primary" className="mb-2 me-2" onClick={()=>fetchData(selectedDevice, selectedCompany)}>{t('Common.Btn.Refresh')}</Button>
                    <div className="mb-3">
                        <Input
                            name="searchWord"
                            className="form-control"
                            placeholder={t('Common.Btn.Search')}
                            type="text"
                            value={searchWord}
                            onChange={(event) => {
                                setSearchWord(event.target.value);
                            }}
                        />
                    </div>
                    <CompanyDropdown onChange={handleSelectCompany} companyID={selectedCompany} />
                    <DeviceDropdown onChange={handleSelectDevice} companyID={selectedCompany} deviceID={selectedDevice} />
                    <IssueStatusDropdown onChange={handleSelectStatus} statusValue={selectedStatus} />
                    <LimitDropdown
                        selectedCompany={selectedCompany}
                        selectedDevice={selectedDevice}
                        limit={limit}
                        setLimit={setLimit}
                    />

                </div>
                <Button size="sm" color="secondary" className="mb-2 me-2" onClick={() => { setIssueID(undefined); setModalDevice(null); setShowModal(true); }}>{t('PageAdmin.Btn.CreateDeviceIssue')}</Button>
            </div>


            <div className="device-table" style={{ maxHeight: '100%', overflowY: 'auto' }}>
                <Table className="table-nowrap mb-3">
                    <thead className="table-light sticky-header">
                        <tr>
                            <th scope="col"></th>
                            <th scope="col">{t('PageAdmin.CompanyDeviceIssueTable.IssueID')}</th>
                            <th scope="col">{t('PageAdmin.CompanyDeviceIssueTable.DeviceID')}</th>
                            <th scope="col">{t('PageAdmin.CompanyDeviceIssueTable.SystemDeviceID')}</th>
                            <th scope="col">{t('PageAdmin.CompanyTable.Name')}</th>
                            <th scope="col">{t('PageAdmin.CompanyDeviceIssueTable.CreatedAt')}</th>
                            <th scope="col">{t('PageAdmin.CompanyDeviceIssueTable.Status')}</th>
                            <th scope="col">{t('PageAdmin.CompanyDeviceIssueTable.Info')}</th>
                            <th scope="col">{t('PageAdmin.CompanyDeviceIssueTable.Action')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {issues.map((id) => {
                            return (
                                <AdminDeviceIssueRow
                                    data={id}
                                    key={id}
                                    isIssueUpdate={true}
                                    setOpenCreateUpdateModal={setShowCreateUpdateModal}
                                    fetchData={() => fetchData(selectedDevice, selectedCompany, selectedStatus)}
                                />
                            );
                        })}
                    </tbody>
                </Table>
                <AdminDeviceRecordModal show={isShowModal} onCloseClick={()=>{setShowModal(false)}} data={modalDevice} selectedCompany={selectedCompany} fetchData={() => {
                    if (issueID===undefined) {
                        fetchData(selectedDevice, selectedCompany, selectedStatus);
                    }
                    else {
                        dispatch(getAdminCompanyDeviceUpdateForIssue(issueID));
                    }
                }} isIssueUpdate={true} issueID={issueID}/>
            </div>
        </Fragment>
    );
}

export default AdminDeviceIssue;